// Social-card image URL.
//
// Every image the admin uploads is converted to WebP (see uploadProductImage),
// and WhatsApp / Facebook link previews do not render a WebP og:image — shares
// came through with no picture at all. Supabase Storage's transform endpoint
// re-encodes the same object to JPEG, so we point og:image at that instead of
// the raw object. Non-Supabase URLs (the logo fallback) pass through unchanged.
//
// resize=contain scales to fit the width and keeps the aspect ratio — a forced
// 1200x630 card crop would slice the top and bottom off the square product
// shots. The share platforms crop to their own card shape anyway.

export const OG_WIDTH = 1200;

const PUBLIC_OBJECT = /^(https?:\/\/[^/]+)\/storage\/v1\/object\/public\/(.+)$/;

/**
 * @returns {{ url: string, jpeg: boolean }} `jpeg` is true when we transformed,
 * i.e. when declaring an image/jpeg og:image:type is truthful.
 */
export function socialImage(src) {
  const s = String(src || '').split('#')[0].split('?')[0];
  const m = s.match(PUBLIC_OBJECT);
  if (!m) return { url: String(src || ''), jpeg: false };
  return {
    url: `${m[1]}/storage/v1/render/image/public/${m[2]}?width=${OG_WIDTH}&resize=contain`,
    jpeg: true,
  };
}

export default socialImage;
